import { render, staticRenderFns } from "./GoodsCon.vue?vue&type=template&id=ececfe82&scoped=true&"
import script from "./GoodsCon.vue?vue&type=script&lang=js&"
export * from "./GoodsCon.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCon.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GoodsCon.vue?vue&type=style&index=1&id=ececfe82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ececfe82",
  null
  
)

export default component.exports